var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProintegridad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 640 323",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#linear-gradient2);\n      }\n\n      .st1 {\n        clip-path: url(#clippath-6);\n      }\n\n      .st2 {\n        clip-path: url(#clippath-7);\n      }\n\n      .st3 {\n        clip-path: url(#clippath-17);\n      }\n\n      .st4 {\n        clip-path: url(#clippath-15);\n      }\n\n      .st5 {\n        clip-path: url(#clippath-4);\n      }\n\n      .st6 {\n        mask: url(#mask-1);\n      }\n\n      .st7 {\n        fill: #35b5a9;\n      }\n\n      .st8 {\n        clip-path: url(#clippath-9);\n      }\n\n      .st9 {\n        clip-path: url(#clippath-10);\n      }\n\n      .st10 {\n        mask: url(#mask);\n      }\n\n      .st11 {\n        fill: url(#linear-gradient1);\n      }\n\n      .st12 {\n        clip-path: url(#clippath-11);\n      }\n\n      .st13 {\n        fill: none;\n      }\n\n      .st14 {\n        mask: url(#mask-2);\n      }\n\n      .st15 {\n        clip-path: url(#clippath-1);\n      }\n\n      .st16 {\n        isolation: isolate;\n      }\n\n      .st17 {\n        fill: #03cfb4;\n      }\n\n      .st18 {\n        clip-path: url(#clippath-5);\n      }\n\n      .st19 {\n        clip-path: url(#clippath-8);\n      }\n\n      .st20 {\n        fill: #5257dc;\n      }\n\n      .st21 {\n        clip-path: url(#clippath-3);\n      }\n\n      .st22 {\n        fill: url(#linear-gradient7);\n      }\n\n      .st23 {\n        clip-path: url(#clippath-12);\n      }\n\n      .st24 {\n        fill: url(#linear-gradient4);\n      }\n\n      .st25 {\n        clip-path: url(#clippath-14);\n      }\n\n      .st26 {\n        fill: #acaad9;\n      }\n\n      .st27 {\n        fill: url(#linear-gradient5);\n      }\n\n      .st28 {\n        fill: url(#linear-gradient3);\n      }\n\n      .st29 {\n        fill: url(#linear-gradient6);\n      }\n\n      .st30 {\n        clip-path: url(#clippath-16);\n      }\n\n      .st31 {\n        clip-path: url(#clippath-2);\n      }\n\n      .st32 {\n        clip-path: url(#clippath-13);\n      }\n\n      .st33 {\n        fill: url(#linear-gradient);\n      }\n\n      .st34 {\n        clip-path: url(#clippath);\n      }\n\n      .st35 {\n        mask: url(#mask-3);\n      }\n\n      .st36 {\n        mix-blend-mode: multiply;\n        opacity: .5;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st13",
    x: 317.37,
    y: 77.98,
    width: 8.96,
    height: 43.29
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M321.86,77.99c-2.47,0-4.48,1.89-4.48,4.22v34.85c0,2.33,2.01,4.22,4.48,4.22s4.48-1.89,4.48-4.22v-34.85c0-2.33-2-4.22-4.48-4.22Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -74.56,
    y1: 717.17,
    x2: -69.89,
    y2: 717.17,
    gradientTransform: "translate(183.52 1473.31) rotate(-180) scale(1.92)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#484847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#cecece"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 317.37,
    y: 77.98,
    width: 8.96,
    height: 43.29,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 317.37,
    y: 77.98,
    width: 8.96,
    height: 43.29
  }), /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 317.37,
    y: 77.99,
    width: 8.96,
    height: 43.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 317.38,
    y: 77.99,
    width: 8.96,
    height: 43.29
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st13",
    x: 317.37,
    y: 77.98,
    width: 8.96,
    height: 43.29
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st13",
    x: 317.37,
    y: 77.99,
    width: 8.96,
    height: 43.29
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: -74.56,
    y1: 717.17,
    x2: -69.88,
    y2: 717.17,
    gradientTransform: "translate(183.52 1473.31) rotate(-180) scale(1.92)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#fafdfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#eef9fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#daf3f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#bde9f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#98dee7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#6acfdd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#36bed1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05afc6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st13",
    x: 269.33,
    y: 47.51,
    width: 94.76,
    height: 95.55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M310.1,76.68c-1.83.64-2.98,2.36-3,4.19v.07c0,.48.09.96.26,1.45l10.27,29.31c.64,1.82,2.32,2.96,4.14,3h.19c.46,0,.93-.09,1.38-.25,1.84-.65,2.99-2.37,3-4.21v-.03c0-.49-.08-.98-.26-1.47l-10.27-29.31c-.65-1.84-2.38-2.99-4.22-2.99-.5,0-1,.08-1.48.25"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st13",
    x: 299,
    y: 73.36,
    width: 35.44,
    height: 43.84,
    transform: "translate(-9.5 149.8) rotate(-26.23)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient2",
    x1: -78.28,
    y1: 484.36,
    x2: -73.6,
    y2: 484.36,
    gradientTransform: "translate(77.81 -1440.05) rotate(-180) scale(3.17 -3.17)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    x: 269.33,
    y: 47.51,
    width: 94.77,
    height: 95.56,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 269.33,
    y: 47.51,
    width: 94.76,
    height: 95.55
  }), /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 291.14,
    y: 67.79,
    width: 51.16,
    height: 54.99
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 281.61,
    y: 59.31,
    width: 70.2,
    height: 71.94,
    transform: "translate(-9.5 149.77) rotate(-26.23)"
  }))))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st13",
    x: 269.33,
    y: 47.51,
    width: 94.76,
    height: 95.55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st13",
    x: 299,
    y: 73.36,
    width: 35.44,
    height: 43.84,
    transform: "translate(-9.5 149.8) rotate(-26.23)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient3",
    x1: -78.28,
    y1: 484.36,
    x2: -73.6,
    y2: 484.36,
    gradientTransform: "translate(77.81 -1440.05) rotate(-180) scale(3.17 -3.17)",
    xlinkHref: "#linear-gradient1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st13",
    x: 156.41,
    y: 37.33,
    width: 38.36,
    height: 185.28
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M175.59,37.33c-10.59,0-19.18,8.08-19.18,18.06v149.17c0,9.97,8.59,18.05,19.18,18.05s19.07-7.98,19.18-17.87V55.21c-.1-9.89-8.65-17.88-19.18-17.88Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient4",
    x1: 6.69,
    y1: 587.68,
    x2: 11.37,
    y2: 587.68,
    gradientTransform: "translate(249.64 4948.03) rotate(-180) scale(8.2)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 156.41,
    y: 37.33,
    width: 38.36,
    height: 185.28,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 156.41,
    y: 37.33,
    width: 38.35,
    height: 185.28
  }), /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 156.41,
    y: 37.33,
    width: 38.35,
    height: 185.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 156.42,
    y: 37.33,
    width: 38.35,
    height: 185.28
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st13",
    x: 156.41,
    y: 37.33,
    width: 38.36,
    height: 185.28
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st13",
    x: 156.41,
    y: 37.33,
    width: 38.36,
    height: 185.28
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient5",
    x1: 6.69,
    y1: 587.68,
    x2: 11.37,
    y2: 587.68,
    gradientTransform: "translate(249.64 4948.03) rotate(-180) scale(8.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#fafdfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#eef9fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#daf3f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#bdeaf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#98dee7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#6bcfdd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#36bed1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05afc6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st13",
    x: -49.21,
    y: -93.14,
    width: 405.62,
    height: 409.01
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M131.55,30.66c-2.09,0-4.21.35-6.29,1.09-7.87,2.76-12.81,10.14-12.83,18.04v.11c0,2.09.35,4.22,1.09,6.29l43.98,125.46c2.77,7.89,10.18,12.84,18.1,12.84,2.11,0,4.25-.36,6.35-1.09,9.99-3.5,15.25-14.45,11.75-24.45l-43.99-125.45c-2.76-7.87-10.13-12.81-18.04-12.83h-.12Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st13",
    x: 77.76,
    y: 17.54,
    width: 151.68,
    height: 187.66,
    transform: "translate(-33.4 79.34) rotate(-26.23)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient6",
    x1: 0.35,
    y1: 532.86,
    x2: 5.02,
    y2: 532.86,
    gradientTransform: "translate(197.76 -7118.39) rotate(-180) scale(13.57 -13.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    x: -49.21,
    y: -93.14,
    width: 405.62,
    height: 409.01,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -49.21,
    y: -93.14,
    width: 405.61,
    height: 409.01
  }), /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.1,
    y: -6.32,
    width: 219,
    height: 235.37
  }), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st29",
    x: 3.36,
    y: -42.59,
    width: 300.47,
    height: 307.92,
    transform: "translate(-33.4 79.34) rotate(-26.23)"
  }))))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st13",
    x: -49.21,
    y: -93.14,
    width: 405.62,
    height: 409.01
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st13",
    x: 77.76,
    y: 17.54,
    width: 151.68,
    height: 187.66,
    transform: "translate(-33.4 79.34) rotate(-26.23)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient7",
    x1: 0.35,
    y1: 532.86,
    x2: 5.02,
    y2: 532.86,
    gradientTransform: "translate(197.76 -7118.39) rotate(-180) scale(13.57 -13.57)",
    xlinkHref: "#linear-gradient5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M214.72,136.39c-.95,0-1.42-.45-1.42-1.35v-47.19c0-.9.47-1.36,1.42-1.36h19.54c6.13,0,11.08,1.62,14.86,4.85,3.78,3.23,5.67,7.46,5.67,12.69s-1.94,9.79-5.81,13.11c-3.87,3.33-8.95,4.99-15.22,4.99h-9.27v12.9c0,.9-.45,1.35-1.36,1.35h-8.41ZM224.49,112.86h8.7c3.04,0,5.53-.82,7.49-2.46,1.95-1.64,2.92-3.77,2.92-6.38,0-2.42-.96-4.4-2.88-5.92-1.93-1.52-4.44-2.28-7.52-2.28h-8.7v17.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M288.75,101.32c.81.19,1.16.71,1.07,1.57l-.93,6.84c-.14.86-.66,1.21-1.57,1.07-1.19-.24-2.49-.36-3.92-.36-2.76,0-5.02.83-6.77,2.5-1.76,1.66-2.64,3.92-2.64,6.77v15.33c0,.9-.45,1.35-1.35,1.35h-7.99c-.9,0-1.36-.45-1.36-1.35v-22.38c0-1.85-.93-2.78-2.78-2.78-.19,0-.71.07-1.57.22-1.05,0-1.57-.38-1.57-1.14v-5.84c0-.81.36-1.33,1.07-1.57,1.67-.57,3.38-.86,5.13-.86,4.28,0,7.15,1.61,8.63,4.85,2.95-3.23,6.82-4.85,11.62-4.85,1.99,0,3.64.22,4.92.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M321.85,123.96c-2.47,0-4.48-2.01-4.48-4.48v-37.01c0-2.47,2.01-4.48,4.48-4.48s4.48,2,4.48,4.48v37.01c0,2.47-2.01,4.48-4.48,4.48"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st36"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st34"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st31"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st11",
    x: 317.37,
    y: 77.99,
    width: 8.96,
    height: 43.29
  }))))))), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M321.85,114.7c-1.85,0-3.58-1.16-4.23-3l-10.27-29.31c-.82-2.33.41-4.89,2.75-5.71,2.33-.82,4.89.41,5.71,2.74l10.28,29.31c.82,2.33-.41,4.89-2.75,5.71-.49.17-.99.25-1.48.25"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st36"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st28",
    x: 281.61,
    y: 59.31,
    width: 70.2,
    height: 71.94,
    transform: "translate(-9.5 149.77) rotate(-26.23)"
  }))))))), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M307.63,136.39c-1.8,0-3.61-.26-5.38-.79-7.96-2.36-13.39-9.51-13.52-17.81-.04-2.47,1.94-4.51,4.41-4.55,2.43-.05,4.51,1.94,4.55,4.41.07,4.36,2.92,8.11,7.1,9.35,5.24,1.55,10.77-1.45,12.32-6.69,1.55-5.24-1.45-10.77-6.69-12.31-3.44-1.02-7.17-.09-9.75,2.41-1.77,1.73-4.61,1.69-6.33-.08-1.73-1.77-1.69-4.61.08-6.34,4.89-4.77,12-6.52,18.54-4.58,9.98,2.95,15.69,13.48,12.74,23.45-1.44,4.84-4.66,8.82-9.09,11.23-2.81,1.53-5.88,2.3-8.98,2.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M321.86,113.62c-1.31,0-2.62-.58-3.5-1.69l-18.08-22.67c-1.54-1.93-1.22-4.75.71-6.29,1.93-1.54,4.75-1.23,6.3.71l18.07,22.67c1.54,1.94,1.23,4.75-.71,6.3-.82.66-1.81.98-2.79.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M214.65,197.27c-.9,0-1.36-.45-1.36-1.36v-6.77c0-.9.45-1.35,1.36-1.35h7.06v-30.94h-7.06c-.9,0-1.36-.45-1.36-1.36v-6.77c0-.9.45-1.36,1.36-1.36h25.31c.95,0,1.43.45,1.43,1.36v6.77c0,.9-.48,1.36-1.43,1.36h-7.06v30.94h7.06c.95,0,1.43.45,1.43,1.35v6.77c0,.9-.48,1.36-1.43,1.36h-25.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M270.61,161.55c4.66,0,8.41,1.44,11.26,4.31,2.85,2.88,4.28,6.69,4.28,11.44v18.61c0,.9-.45,1.36-1.36,1.36h-7.98c-.95,0-1.43-.45-1.43-1.36v-17.18c0-2.42-.68-4.37-2.03-5.84-1.36-1.47-3.17-2.21-5.46-2.21s-4.29.7-5.74,2.11c-1.46,1.4-2.18,3.27-2.18,5.6v17.54c0,.9-.45,1.36-1.36,1.36h-7.98c-.9,0-1.36-.45-1.36-1.36v-22.38c0-1.85-.93-2.78-2.78-2.78-.19,0-.71.07-1.57.22-1.05,0-1.57-.38-1.57-1.14v-5.85c0-.8.36-1.33,1.07-1.57,1.47-.57,3.19-.86,5.13-.86,4.09,0,6.94,1.5,8.56,4.49,2.99-2.99,7.15-4.49,12.47-4.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M311.53,198.41c-4.66,0-8.33-1.32-11.01-3.96-2.69-2.63-4.03-6.24-4.03-10.8v-12.33h-6.56c-.9,0-1.35-.45-1.35-1.35v-5.92c0-.9.45-1.36,1.35-1.36h6.56v-9.05c0-.9.45-1.35,1.36-1.35h7.98c.9,0,1.35.45,1.35,1.35v9.05h11.2c.9,0,1.35.45,1.35,1.36v5.92c0,.9-.45,1.35-1.35,1.35h-11.2v11.98c0,1.81.54,3.23,1.6,4.28,1.07,1.04,2.51,1.57,4.31,1.57s3.64-.21,5.35-.64c.9-.14,1.43.22,1.57,1.07l.93,6.13c.05.76-.31,1.28-1.07,1.57-3.05.76-5.82,1.14-8.34,1.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M343.32,198.41c-5.85,0-10.58-1.68-14.19-5.06-3.61-3.37-5.42-7.81-5.42-13.33s1.75-10.03,5.24-13.4c3.49-3.37,8.07-5.06,13.73-5.06s10.23,1.66,13.58,4.99c3.35,3.33,5.02,7.72,5.02,13.19,0,.29,0,.7-.03,1.25-.02.55-.04.94-.04,1.17-.14.81-.64,1.21-1.5,1.21h-25.59c.57,2.14,1.7,3.83,3.39,5.06,1.69,1.24,3.7,1.85,6.02,1.85,2.62,0,4.57-.71,5.85-2.14.62-.47,1.19-.71,1.71-.71h7.98c.52,0,.89.13,1.1.39.22.26.22.61.04,1.03-1.24,2.95-3.35,5.28-6.34,6.99-2.99,1.71-6.51,2.56-10.55,2.56M334.05,177.02h17.04c-.1-2.23-.88-4.05-2.35-5.46-1.47-1.4-3.4-2.1-5.77-2.1s-4.31.7-5.96,2.1c-1.64,1.4-2.62,3.22-2.96,5.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M403.48,162.69c.9,0,1.35.45,1.35,1.35v34.08c0,5.03-1.75,9.11-5.27,12.23-3.52,3.11-8.13,4.67-13.83,4.67-5.13,0-9.42-1.19-12.87-3.57-3.45-2.38-5.53-5.54-6.24-9.48-.24-.9.19-1.35,1.28-1.35h7.99c.66,0,1.18.36,1.57,1.07.47,1.43,1.45,2.55,2.92,3.39,1.47.83,3.23,1.25,5.28,1.25,2.57,0,4.61-.74,6.13-2.21,1.52-1.47,2.28-3.44,2.28-5.91v-2.99c-2.71,2.04-6.01,3.06-9.91,3.06-5.46,0-9.96-1.72-13.47-5.17-3.52-3.44-5.27-7.85-5.27-13.22s1.75-9.76,5.27-13.19c3.52-3.42,8.01-5.13,13.47-5.13,3.94,0,7.32,1.09,10.12,3.28v-.79c0-.9.45-1.35,1.35-1.35h7.84ZM385.09,189.85c2.66,0,4.82-.93,6.49-2.78,1.66-1.85,2.49-4.25,2.49-7.2s-.85-5.35-2.53-7.2c-1.69-1.85-3.84-2.78-6.45-2.78s-4.86.94-6.59,2.82c-1.74,1.88-2.6,4.26-2.6,7.16s.85,5.35,2.56,7.2c1.71,1.85,3.92,2.78,6.63,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M440.62,162.19c.81.19,1.16.71,1.07,1.57l-.93,6.84c-.14.86-.66,1.21-1.57,1.07-1.19-.23-2.49-.36-3.92-.36-2.76,0-5.02.83-6.77,2.5-1.76,1.66-2.64,3.92-2.64,6.77v15.33c0,.9-.45,1.35-1.35,1.35h-7.99c-.9,0-1.36-.45-1.36-1.35v-22.38c0-1.86-.93-2.78-2.78-2.78-.19,0-.71.07-1.57.22-1.05,0-1.57-.38-1.57-1.14v-5.84c0-.81.36-1.33,1.07-1.57,1.67-.57,3.38-.86,5.13-.86,4.28,0,7.15,1.61,8.63,4.85,2.95-3.23,6.82-4.85,11.62-4.85,1.99,0,3.64.22,4.92.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M447.61,197.27c-.9,0-1.36-.45-1.36-1.36v-31.86c0-.9.45-1.36,1.36-1.36h7.99c.9,0,1.35.45,1.35,1.36v31.86c0,.9-.45,1.36-1.35,1.36h-7.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M508.42,196.05c.14.81-.22,1.31-1.07,1.5-1.95.57-3.78.86-5.49.86-4.42,0-7.42-1.5-8.98-4.49-3.13,2.99-7.08,4.49-11.83,4.49-5.52,0-10.02-1.71-13.51-5.13-3.49-3.42-5.24-7.84-5.24-13.26s1.75-9.91,5.24-13.33c3.49-3.42,8-5.13,13.51-5.13,3.8,0,7.1,1.02,9.91,3.07v-18.75c0-.9.45-1.35,1.35-1.35h8.06c.9,0,1.35.45,1.35,1.35v40.63c0,1.81.79,2.71,2.35,2.71.86,0,1.57-.07,2.14-.22,1-.09,1.52.29,1.57,1.14l.64,5.92ZM481.97,190.06c2.66,0,4.82-.94,6.49-2.82,1.66-1.88,2.49-4.29,2.49-7.23s-.83-5.43-2.49-7.31c-1.67-1.88-3.83-2.82-6.49-2.82s-4.92.94-6.63,2.82c-1.71,1.88-2.57,4.31-2.57,7.31s.86,5.36,2.57,7.23c1.71,1.88,3.92,2.82,6.63,2.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M557.39,196.05c.09.81-.29,1.31-1.14,1.5-1.95.57-3.73.86-5.35.86-4.37,0-7.36-1.45-8.98-4.35-3.33,2.9-7.32,4.35-11.98,4.35-5.52,0-10.02-1.71-13.51-5.13-3.49-3.42-5.24-7.84-5.24-13.26s1.75-9.91,5.24-13.33c3.49-3.42,8-5.13,13.51-5.13,3.94,0,7.32,1.09,10.12,3.28v-.79c0-.9.45-1.35,1.35-1.35h7.84c.9,0,1.35.45,1.35,1.35v22.39c0,1.85.79,2.78,2.35,2.78.86,0,1.6-.07,2.21-.22.95-.09,1.45.29,1.5,1.14l.71,5.92ZM530.87,190.06c2.66,0,4.82-.94,6.49-2.82,1.66-1.88,2.49-4.29,2.49-7.23s-.83-5.43-2.49-7.31c-1.67-1.88-3.83-2.82-6.49-2.82s-4.92.94-6.63,2.82-2.57,4.31-2.57,7.31.86,5.36,2.57,7.23c1.71,1.88,3.92,2.82,6.63,2.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M606.15,196.05c.14.81-.22,1.31-1.07,1.5-1.95.57-3.78.86-5.49.86-4.42,0-7.42-1.5-8.98-4.49-3.13,2.99-7.08,4.49-11.83,4.49-5.52,0-10.02-1.71-13.51-5.13-3.49-3.42-5.24-7.84-5.24-13.26s1.75-9.91,5.24-13.33c3.49-3.42,8-5.13,13.51-5.13,3.8,0,7.1,1.02,9.91,3.07v-18.75c0-.9.45-1.35,1.35-1.35h8.06c.9,0,1.35.45,1.35,1.35v40.63c0,1.81.79,2.71,2.35,2.71.86,0,1.57-.07,2.14-.22,1-.09,1.52.29,1.57,1.14l.64,5.92ZM579.7,190.06c2.66,0,4.82-.94,6.49-2.82,1.66-1.88,2.49-4.29,2.49-7.23s-.83-5.43-2.49-7.31c-1.67-1.88-3.83-2.82-6.49-2.82s-4.92.94-6.63,2.82c-1.71,1.88-2.57,4.31-2.57,7.31s.86,5.36,2.57,7.23c1.71,1.88,3.92,2.82,6.63,2.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M458.01,156.72c-1.67,1.58-3.77,2.37-6.26,2.37s-4.58-.79-6.26-2.37c-1.68-1.58-2.52-3.52-2.52-5.82s.84-4.22,2.52-5.77c1.67-1.54,3.76-2.32,6.26-2.32s4.59.78,6.26,2.32c1.67,1.54,2.52,3.47,2.52,5.77s-.84,4.24-2.52,5.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M242.73,219.27c0,.46-.25.7-.76.7h-23.56v13.75h21.13c.5,0,.75.23.75.7v3.08c0,.5-.25.75-.75.75h-21.13v13.41h23.56c.51,0,.76.23.76.7v3.07c0,.46-.25.7-.76.7h-27.97c-.46,0-.7-.23-.7-.7v-39.24c0-.46.23-.7.7-.7h27.97c.51,0,.76.23.76.7v3.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M288.06,227.86c3.64,0,6.53,1.14,8.68,3.42s3.22,5.3,3.22,9.05v15.09c0,.46-.23.7-.7.7h-3.54c-.47,0-.7-.23-.7-.7v-14.86c0-2.59-.7-4.65-2.09-6.15-1.39-1.51-3.35-2.26-5.86-2.26s-4.37.82-5.81,2.47c-1.43,1.65-2.14,3.84-2.14,6.59v14.22c0,.46-.23.7-.7.7h-3.59c-.47,0-.7-.23-.7-.7v-14.86c0-2.55-.67-4.59-2.03-6.12-1.35-1.53-3.19-2.29-5.51-2.29-2.52,0-4.56.85-6.12,2.55-1.57,1.7-2.35,3.93-2.35,6.68v14.04c0,.46-.23.7-.7.7h-3.54c-.47,0-.7-.23-.7-.7v-20.02c0-2.13-.91-3.19-2.73-3.19-.54,0-1.2.07-1.97.23-.54.08-.81-.12-.81-.58l-.06-2.67c0-.43.19-.7.58-.81.97-.35,2.05-.52,3.25-.52,3.36,0,5.36,1.59,5.97,4.76,2.36-3.17,5.73-4.76,10.1-4.76s7.8,1.86,9.69,5.57c2.2-3.71,5.82-5.57,10.85-5.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M325.61,227.86c4.22,0,7.73,1.38,10.54,4.15,2.8,2.77,4.21,6.24,4.21,10.42s-1.4,7.6-4.21,10.36c-2.81,2.77-6.32,4.15-10.54,4.15s-7.35-1.57-9.87-4.7v16.43c0,.46-.23.7-.7.7h-3.54c-.46,0-.7-.23-.7-.7v-33.26c0-2.13-.91-3.19-2.73-3.19-.54,0-1.2.07-1.97.23-.54.08-.81-.12-.81-.58l-.06-2.67c0-.43.2-.7.58-.81.97-.35,2.05-.52,3.25-.52,1.62,0,2.97.44,4.03,1.34,1.07.89,1.75,2.11,2.06,3.65,2.67-3.33,6.15-4.99,10.45-4.99M325.49,252.82c2.83,0,5.18-1,7.08-2.99,1.9-1.99,2.84-4.46,2.84-7.4s-.95-5.46-2.84-7.46c-1.89-1.99-4.25-2.99-7.08-2.99s-5.06,1-6.93,2.99c-1.88,1.99-2.82,4.48-2.82,7.46s.94,5.41,2.82,7.4c1.88,1.99,4.18,2.99,6.93,2.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M369.96,228.62c.43.12.6.39.52.81l-.47,2.9c-.07.46-.36.64-.87.52-1.04-.35-2.36-.52-3.94-.52-2.79,0-5.07.95-6.85,2.84-1.78,1.89-2.67,4.37-2.67,7.43v12.83c0,.46-.23.7-.7.7h-3.54c-.46,0-.69-.23-.69-.7v-20.02c0-2.13-.91-3.2-2.73-3.2-.54,0-1.2.08-1.97.23-.55.08-.81-.12-.81-.58l-.06-2.67c0-.43.19-.7.58-.81.97-.35,2.05-.52,3.25-.52,1.7,0,3.09.45,4.15,1.36,1.07.91,1.71,2.18,1.95,3.8,2.47-3.44,5.84-5.17,10.1-5.17,1.82,0,3.4.25,4.76.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M388.82,256.94c-4.45,0-8.06-1.33-10.83-4-2.77-2.67-4.15-6.17-4.15-10.5s1.35-7.85,4.06-10.54c2.71-2.69,6.25-4.04,10.62-4.04s7.69,1.35,10.3,4.04c2.61,2.69,3.92,6.18,3.92,10.48,0,.15,0,.4-.03.73-.02.33-.03.59-.03.79-.12.35-.35.52-.7.52h-23.16c.38,2.55,1.5,4.61,3.34,6.19,1.84,1.56,4.07,2.35,6.7,2.35,3.49,0,5.94-1.09,7.37-3.25.27-.27.56-.41.87-.41h3.83c.62,0,.81.27.58.81-.97,2.09-2.6,3.75-4.87,4.99-2.28,1.24-4.9,1.86-7.84,1.86M378.72,240.81h18.98c-.08-2.51-.93-4.63-2.55-6.36-1.63-1.72-3.79-2.58-6.5-2.58s-4.98.83-6.82,2.49c-1.84,1.66-2.87,3.81-3.11,6.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M421.67,256.94c-3.83,0-6.91-.75-9.23-2.26-2.32-1.51-3.73-3.64-4.23-6.39-.08-.5.15-.75.7-.75h3.25c.31,0,.56.22.76.64,1.04,3.29,3.96,4.93,8.76,4.93,2.13,0,3.85-.41,5.17-1.22,1.31-.81,1.97-1.86,1.97-3.13,0-1.39-.67-2.44-2-3.13-1.33-.7-2.95-1.17-4.85-1.42-1.89-.25-3.8-.56-5.72-.93-1.91-.36-3.54-1.14-4.88-2.32-1.34-1.18-2-2.81-2-4.9,0-2.44,1.06-4.41,3.19-5.92,2.13-1.51,4.91-2.26,8.36-2.26s6.12.74,8.38,2.21c2.26,1.47,3.59,3.39,3.98,5.75.08.51-.15.76-.7.76h-3.25c-.39,0-.64-.15-.76-.47-.39-1.43-1.25-2.55-2.61-3.34-1.36-.8-3.02-1.19-4.99-1.19s-3.69.37-4.9,1.1c-1.22.74-1.83,1.7-1.83,2.9s.47,2.14,1.42,2.82c.95.68,2.14,1.11,3.57,1.31,1.43.2,2.99.46,4.67.79,1.68.33,3.24.71,4.67,1.13,1.43.43,2.62,1.22,3.57,2.38.95,1.16,1.42,2.65,1.42,4.47,0,2.55-1.09,4.6-3.28,6.15-2.18,1.55-5.06,2.32-8.62,2.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M475.19,255.55c.04.43-.14.7-.52.81-1.16.38-2.33.58-3.49.58-3.52,0-5.59-1.62-6.21-4.88-2.83,3.26-6.31,4.88-10.45,4.88s-7.74-1.38-10.56-4.15c-2.83-2.76-4.24-6.22-4.24-10.36s1.4-7.65,4.21-10.42c2.81-2.76,6.34-4.15,10.6-4.15,3.91,0,7.18,1.51,9.81,4.53v-3.02c0-.46.23-.7.7-.7h3.6c.46,0,.69.23.69.7v20.08c0,2.09.81,3.13,2.44,3.13.73,0,1.51-.07,2.33-.23.46-.12.73.06.81.52l.29,2.67ZM454.58,252.82c2.78,0,5.11-.99,6.97-2.96,1.86-1.97,2.78-4.45,2.78-7.43s-.93-5.46-2.78-7.46c-1.86-1.99-4.18-2.99-6.97-2.99s-5.18,1-7.08,2.99c-1.9,1.99-2.84,4.48-2.84,7.46s.95,5.41,2.84,7.4c1.89,1.99,4.25,2.99,7.08,2.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M493.06,256.94c-3.83,0-6.91-.75-9.23-2.26-2.32-1.51-3.73-3.64-4.23-6.39-.08-.5.15-.75.7-.75h3.25c.31,0,.56.22.76.64,1.04,3.29,3.97,4.93,8.76,4.93,2.13,0,3.85-.41,5.17-1.22,1.31-.81,1.97-1.86,1.97-3.13,0-1.39-.67-2.44-2-3.13-1.33-.7-2.95-1.17-4.85-1.42-1.89-.25-3.8-.56-5.72-.93-1.91-.36-3.54-1.14-4.88-2.32-1.34-1.18-2-2.81-2-4.9,0-2.44,1.06-4.41,3.19-5.92,2.13-1.51,4.91-2.26,8.36-2.26s6.12.74,8.39,2.21c2.26,1.47,3.58,3.39,3.97,5.75.08.51-.15.76-.7.76h-3.25c-.39,0-.64-.15-.76-.47-.39-1.43-1.25-2.55-2.61-3.34-1.36-.8-3.02-1.19-4.99-1.19s-3.69.37-4.9,1.1c-1.22.74-1.83,1.7-1.83,2.9s.47,2.14,1.42,2.82c.95.68,2.14,1.11,3.57,1.31,1.43.2,2.99.46,4.67.79,1.68.33,3.24.71,4.67,1.13,1.43.43,2.62,1.22,3.57,2.38.95,1.16,1.42,2.65,1.42,4.47,0,2.55-1.09,4.6-3.28,6.15-2.18,1.55-5.06,2.32-8.62,2.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M175.59,234.11c-10.59,0-19.18-8.59-19.18-19.18V56.51c0-10.59,8.59-19.18,19.18-19.18s19.18,8.59,19.18,19.18v158.42c0,10.59-8.59,19.18-19.18,19.18"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st36"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st23"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st27",
    x: 156.41,
    y: 37.33,
    width: 38.36,
    height: 185.28
  }))))))), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M175.59,194.49c-7.92,0-15.33-4.95-18.1-12.84l-43.99-125.45c-3.5-10,1.76-20.94,11.75-24.45,10.01-3.5,20.94,1.76,24.45,11.75l43.98,125.45c3.51,9.99-1.75,20.94-11.75,24.45-2.1.73-4.24,1.09-6.34,1.09"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st36"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st32"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st35"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st30"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st22",
    x: 3.36,
    y: -42.59,
    width: 300.47,
    height: 307.92,
    transform: "translate(-33.4 79.34) rotate(-26.23)"
  }))))))), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M114.72,287.32c-7.71,0-15.45-1.11-23.05-3.36-34.07-10.09-57.33-40.73-57.86-76.23-.16-10.59,8.3-19.31,18.89-19.47,10.41-.19,19.3,8.3,19.47,18.89.28,18.64,12.49,34.73,30.39,40.03,22.44,6.64,46.09-6.2,52.73-28.64,6.64-22.43-6.2-46.08-28.64-52.73-14.72-4.36-30.7-.4-41.7,10.33-7.59,7.4-19.73,7.23-27.12-.35-7.39-7.59-7.24-19.73.35-27.12,20.95-20.41,51.36-27.93,79.37-19.64,42.71,12.65,67.17,57.69,54.52,100.4-6.13,20.69-19.94,37.76-38.91,48.06-12,6.52-25.16,9.83-38.44,9.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M175.6,189.87c-5.63,0-11.22-2.47-15.01-7.22l-77.36-97.04c-6.6-8.28-5.24-20.35,3.04-26.95,8.28-6.6,20.35-5.24,26.95,3.04l77.37,97.04c6.6,8.28,5.24,20.35-3.04,26.95-3.53,2.81-7.75,4.18-11.94,4.18"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProintegridad);
export default __webpack_public_path__ + "static/media/prointegridad.bc75f8508621560bbf44c672f57f207b.svg";
export { ForwardRef as ReactComponent };